export default __webpack_public_path__ + "locales/lo-LA/EmptyTrashDialog.json?hash=91e304ea73ab9e7c8a17062bf6bebbcd";